export var WebhookModels;
(function (WebhookModels) {
    class WebhookTransitionsTo {
        constructor(data) {
            this.id = data.id;
        }
    }
    WebhookModels.WebhookTransitionsTo = WebhookTransitionsTo;
    class WebhookWorkflowStepChanges {
        constructor(data) {
            this.type = data.type;
            this.transitionsTo = data.transitionsTo;
        }
    }
    WebhookModels.WebhookWorkflowStepChanges = WebhookWorkflowStepChanges;
    class WebhookDeliveryApiContentChanges {
        constructor(data) {
            this.type = data.type;
            this.operations = data.operations;
        }
    }
    WebhookModels.WebhookDeliveryApiContentChanges = WebhookDeliveryApiContentChanges;
    class Webhook {
        constructor(data) {
            this.id = data.id;
            this.name = data.name;
            this.secret = data.secret;
            this.url = data.url;
            this.triggers = data.triggers;
            this.lastModified = data.lastModified;
        }
    }
    WebhookModels.Webhook = Webhook;
})(WebhookModels || (WebhookModels = {}));
//# sourceMappingURL=webhook.models.js.map